// extracted by mini-css-extract-plugin
module.exports = {"detail":"detail--1PSjwy-jf","changed":"changed--1mjSwMyKc","modal":"modal--2ZEk_nLzY"};